// components
import { Form, Input, Col, Button } from "antd";
import Checkbox from "components/atoms/Checkbox/Checkbox";
import FirstTimeLoginWrapper from "components/molecules/Login/Login";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";
import { Head } from "components/molecules/Head/Head";

// styles
import styles from "containers/UpdateWatchword/updateWatchword.module.css";

// constants
import { FirstTimeLogin as Constants, ForgotWatchword, PageTitles } from "constants/global";

// hooks
import { UpdateWatchwordPropTypes } from "containers/ForgotWatchword/useForgotWatchword";

type ErrorMessageWrapperTypes = {
	fieldError?: boolean;
	message: string;
};

const ErrorMessageWrapper = ({ fieldError, message }: ErrorMessageWrapperTypes) => {
	return fieldError ? <ErrorMessage classes={styles?.err_message} message={message} /> : <></>;
};

const UpdateWatchword = (props: UpdateWatchwordPropTypes) => {
	const [form] = Form.useForm();

	const {
		isExistingWordUsed,
		isVerificationCodeInvalid,
		verificationCode,
		watchWord,
		watchWordChecks,
		confirmWatchword,
		isValidWatchWord,
		isDetailsValid,
		handleVerificationCode,
		confirmForgotWatchword,
		onWatchwordBlur,
		onWatchwordChange,
		setConfirmWatchword
	} = props;

	const passwordStyles = isValidWatchWord === "invalid" || isExistingWordUsed ? styles?.err : styles?.filled;
	const verificationCodeCls = isVerificationCodeInvalid === "invalid" ? styles?.err : styles?.filled;

	return (
		<FirstTimeLoginWrapper page="reset" isDisclaimer={true} disclaimerText={Constants?.DISCLAIMER_TEXT}>
			<div className={styles?.login_form}>
				<Head>{PageTitles.FORGOT_WATCHWORD}</Head>
				<Form form={form} name="update_watchword" onFinish={confirmForgotWatchword} initialValues={{}} scrollToFirstError>
					<Form.Item
						name="verification_code"
						label=""
						extra={<ErrorMessageWrapper fieldError={isVerificationCodeInvalid === "invalid"} message={ForgotWatchword.FP_ERR_INVALID_VERIFICATION_CODE} />}
						rules={[
							{
								required: true,
								message: <ErrorMessage message={ForgotWatchword.FP_ERR_INVALID_VERIFICATION_CODE} />
							}
						]}
					>
						<Input.Password
							value={verificationCode}
							onChange={(e) => handleVerificationCode(e?.target?.value)}
							placeholder={ForgotWatchword.FP_VERIFICATION_CODE_PLACEHOLDER}
							className={`${styles?.new_password} ${verificationCode ? verificationCodeCls : ""}`}
						/>
					</Form.Item>
					<Form.Item
						name="watchword"
						label=""
						extra={<ErrorMessageWrapper fieldError={isValidWatchWord === "invalid"} message={Constants.INVALID_WATCHWORD} />}
						rules={[
							{
								required: true,
								message: <ErrorMessage message={ForgotWatchword.FP_ERR_WATCHWORD} />
							}
						]}
					>
						<Input.Password
							value={watchWord}
							onBlur={() => onWatchwordBlur()}
							onChange={(e) => onWatchwordChange(e?.target?.value)}
							placeholder={ForgotWatchword.FP_WATCHWORD_PLACEHOLDER}
							className={`${styles?.new_password} ${watchWord ? passwordStyles : ""}`}
						/>
					</Form.Item>
					<Col span={32} className={styles?.center}>
						<Checkbox
							id="isMinChar"
							name="watchwordChecks"
							checked={watchWordChecks?.isMinChars}
							classes={{
								checkbox_checked: styles?.checkbox_checked,
								checkbox_input: styles?.checkbox_input,
								checkbox_label: styles?.checkbox_label
							}}
							label={Constants?.CB_LABEL1}
							value="isMinChars"
						/>
					</Col>
					<Col span={32} className={styles?.center}>
						<Checkbox
							id="isUpperCase"
							name="watchwordChecks"
							checked={watchWordChecks?.isUpperCase}
							classes={{
								checkbox_checked: styles?.checkbox_checked,
								checkbox_input: styles?.checkbox_input,
								checkbox_label: styles?.checkbox_label
							}}
							label={Constants?.CB_LABEL2}
							value="isUpperCase"
						/>
					</Col>
					<Col span={32} className={styles?.center}>
						<Checkbox
							id="isLowerCase"
							name="watchwordChecks"
							checked={watchWordChecks?.isLowerCase}
							classes={{
								checkbox_checked: styles?.checkbox_checked,
								checkbox_input: styles?.checkbox_input,
								checkbox_label: styles?.checkbox_label
							}}
							label={Constants?.CB_LABEL3}
							value="isLowerCase"
						/>
					</Col>
					<Col span={32} className={styles?.center}>
						<Checkbox
							id="isSpecialChar"
							name="watchwordChecks"
							checked={watchWordChecks?.isSpecialChar}
							classes={{
								checkbox_checked: styles?.checkbox_checked,
								checkbox_input: styles?.checkbox_input,
								checkbox_label: styles?.checkbox_label
							}}
							label={Constants?.CB_LABEL4}
							value="isSpecialChar"
						/>
					</Col>

					<Form.Item
						label=""
						name="confirm_watchword"
						dependencies={["watchword"]}
						rules={[
							{
								required: true,
								message: <ErrorMessage message={Constants.ERR_CONFIRM_WATCHWORD} />
							},
							({ getFieldValue }) => ({
								validator(_, value) {
									if (!value || getFieldValue("watchword") === value) {
										return Promise.resolve();
									}
									return Promise.reject(new Error(Constants.ERR_WATCHWORD_MATCH));
								}
							})
						]}
					>
						<Input.Password
							className={`${styles?.confirm_new_password} ${confirmWatchword ? styles?.filled : ""}`}
							placeholder={Constants.CONFIRM_WATCHWORD_PLACEHOLDER}
							value={confirmWatchword}
							onChange={(e) => setConfirmWatchword(e.target?.value)}
						/>
					</Form.Item>
					<ErrorMessageWrapper fieldError={isExistingWordUsed} message={ForgotWatchword.CURRENT_WORD_USED_ERR} />
					<Form.Item className={styles?.submit_wrapper}>
						<Button disabled={!isDetailsValid} className={styles?.submit_button} type="primary" htmlType="submit">
							{Constants.SUBMIT_BTN_TEXT}
						</Button>
					</Form.Item>
				</Form>
			</div>
		</FirstTimeLoginWrapper>
	);
};

export default UpdateWatchword;
